const DEFAULT_OPTIONS = Object.freeze({
  removeDiacritics: true,
  trim: true,
  toLowerCase: true,
});

function normalizeText(value, customOptions = {}) {
  const options = {
    ...DEFAULT_OPTIONS,
    ...customOptions,
  };

  let normalized = String(value ?? '');

  if (options.removeDiacritics) {
    normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  if (options.trim) {
    normalized = normalized.trim();
  }

  if (options.toLowerCase) {
    normalized = normalized.toLowerCase();
  }

  return normalized;
}

export { normalizeText };
